import AdminHeader from './admin-header';
import Button from './button';
import Notice from './notice';

export {AdminHeader};
export {Button};
export {Notice};



// WEBPACK FOOTER //
// ./src/components/wp/index.js